module.exports = __webpack_public_path__ + "static/media/trophy.3e634af9.svg";